import moment from 'moment'
/**
 *
 * @param date 时间
 * @param rule 规则
 * YYYY-MM-DD hh:mm:ss
 */
export const baseTime = (date: any, rule: any) => moment(date).format(rule)

export const defaultCron = (date: any) => {
  /**
   * 0 10 16 27 7 ? 2020
   * 秒 分 时 日 月 ? 年
   */
  const _date = new Date(date)
  const YYY = _date.getFullYear()
  const MM = _date.getMonth() + 1
  const DD = _date.getDate()
  const hh = _date.getHours()
  const ss = _date.getMinutes()
  const mm = _date.getSeconds()

  return `${mm} ${ss} ${hh} ${DD} ${MM}?${YYY}`
}

/**
 *
 * @param cron
 * cronToDate corn转date
 */
export const cronToDate = (cron:any) => {
  const _cron = cron.split('?')
  const _cron0 = _cron[0].split(' ').reverse()
  const _date = `${_cron[1]}-${isDataFormat(_cron0[0])}-${isDataFormat(_cron0[1])} ${isDataFormat(_cron0[2])}:${isDataFormat(_cron0[3])}:${isDataFormat(_cron0[4])}`
  return _date
}
cronToDate('0 10 16 27 7 ? 2020')
function isDataFormat(date:string) {
  return (date.toString()).padStart(2, '0')
}
